export default {
	"couponDialog.full": "满",
	"couponDialog.available": "可用",
	"couponDialog.SendYou1Ticket": "送您1张",
	"couponDialog.CouponsThatCanBeOrderedImmediately": "优惠券，可立即下单使用"
}